export enum UserRoles {
  ADMIN = "ADMIN",
  COORDINATOR = "COORDINATOR",
  MARKETING = "MARKETING",
  QUOTE_VIEWER = "QUOTE_VIEWER",
  SURGEON = "SURGEON",
  // Pre-op nurse (2026-08-27, spec D13). Mirrors
  // server/graphql/enums/UserRoles.ts + the SDL enum.
  PREOP = "PREOP",
  // Lane markers (2026-09-03). POSTOP is NO LONGER classification-only as of
  // 2026-09-24 (owner decision D9a): it is a staff role — in the server's
  // ADMIN_SIDE_ROLES, roleHelpers.ts STAFF_ROLES, the AuthenticationProvider
  // login wall, and MainMenu's postopItems. FRONT_DESK stays classification
  // only, no access grant. Mirrors server/graphql/enums/UserRoles.ts.
  POSTOP = "POSTOP",
  FRONT_DESK = "FRONT_DESK",
  // Coordinator menu/access parity, excluded from all assignment logic
  // (2026-09-11). Mirrors server/graphql/enums/UserRoles.ts + the SDL enum.
  PATIENT_EXPERIENCE = "PATIENT_EXPERIENCE",
  // Operating-room staff (OR Board, owner decision D5, 2026-10-05):
  // coordinator-grade access without assignment, like PATIENT_EXPERIENCE, with
  // its own focused menu (MainMenu's orItems). Mirrors
  // server/graphql/enums/UserRoles.ts + the SDL enum.
  OR = "OR",
  // External (non-org) principal (2026-09-19, external-accounts design
  // Phase 3/4) — a CPA/bookkeeper, not staff. Mirrors
  // server/graphql/enums/UserRoles.ts + the SDL enum. Server-side this role
  // is rejected by every requireAdmin/isAdminAuthorized gate and admitted
  // only where a resolver opts in via requireExternal; client-side it must
  // stay out of every staff role check (see MainMenu.tsx's isAccountantOnly).
  ACCOUNTANT = "ACCOUNTANT",
}
